import React from "react";
import WhyMomentum from "./WhyMomentumLanding/WhyMomentum";
import Sung from "./Sung/Sung";
import Art from "./Art/Art";
import Locations from "./Locations/Locations";
import SwipeNav from "../../Components/SwipeNav/SwipeNav";
import NoSubContractors from "./NoSubContractors/NoSubContractors";

let Components = [
  <WhyMomentum />,
  <NoSubContractors />,
  <Locations />,

  <Art />,
  <Sung />,
];

const WhyMomentumHome = () => {
  return <SwipeNav Components={Components}></SwipeNav>;
};

export default WhyMomentumHome;
